'use client'
import { i18n, i18nInit, IPageScrollPosition, StorePageContext, StorePageDynamicContext, toProxy, watchUpdates, storeUtils } from "@fanfanlo";
import { useRouter } from "next/router";
import getConfig from "node_modules/next/config";
import { PropsWithChildren, useEffect, useState } from "react";
import { I18nextProvider } from "react-i18next";
import {trackingPrint} from "@app/model"
checkReloadPage();
i18nInit()


function checkReloadPage(){
  if(typeof window === 'undefined')return
  if(getConfig().publicRuntimeConfig.isDevelopment){
    return
  }
  if(window.location.href.indexOf('qiniu') == -1)return;
  // 帮我检测url中是否包含_htmlRefreshTime的参数
  // 如果没有，则添加_htmlRefresTime的参数，值为当前时间的毫秒数
  const searchParams = new URL(window.location.href).searchParams
  const htmlRefreshTime = searchParams.get('_htmlRefreshTime')
  if (!htmlRefreshTime) {
    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set('_htmlRefreshTime', String(Date.now()))
    window.location.href = newUrl.toString()
    return
  }

  const refreshTime = Number(htmlRefreshTime)
  if (refreshTime + 2 * 60 * 1000 < Date.now()) {
    const newUrl = new URL(window.location.href)
    newUrl.searchParams.set('_htmlRefreshTime', String(Date.now()))
    window.location.href = newUrl.toString()
  }
}
const dynamicKeyMap = new Map<string, boolean>();
export function AppShell({ children }: PropsWithChildren) {
  const router = useRouter();
  const scrollKey = 'scrollPositionInfo'
  const href = window.location.href.split("#")[0]
  const dynamicKey = `dynamic-${href}`
  const [isOpened] = useState(dynamicKeyMap.get(dynamicKey) === true)
  const s = storeUtils.namespace(dynamicKey);
  let o: Record<string, unknown>|undefined = s.read(dynamicKey)
  if (!o) {
    o = {}
    s.write(dynamicKey, o)
  }
  o = toProxy(o)
  useEffect(() => {

    router.beforePopState((state) => {
      s.clearAll()
      return true
    })
  })
  useEffect(() => {
    s.write(dynamicKey, o)
    return watchUpdates(o, () => {
      s.write(dynamicKey, o)
    })
  }, [])

  useEffect(()=>{
    trackingPrint({params:{
      type:"页面进入",
      title:"页面",
      subtitle:"发送者-AppShell",
      extra:{
        href:window.location.href
      }
    }})
  }, [])
  useEffect(() => {
    const info = (s.read(scrollKey) || { x: 0, y: 0 }) as IPageScrollPosition
    // console.log('app shell scroll info info = ', info)
    if (info.x == 0 && info.y == 0) {
      listenScroll()
    } else {
      window.requestAnimationFrame(() => {
        if(isOpened){
          window.scrollTo(info.x, info.y)
        }
        listenScroll()
      })
    }
    function onScroll(e: Event) {
      // console.log('app shell on scroll', { x: window.scrollX, y: window.scrollY })
      s.write(scrollKey, { x: window.scrollX, y: window.scrollY })
    }
    function listenScroll() {
      window.addEventListener('scroll', onScroll)
    }

    function unsub() {
      window.removeEventListener('scroll', onScroll)
    }
    return unsub
  });
  useEffect(()=>{
    dynamicKeyMap.set(dynamicKey, true)
  },[])
  return (
    <StorePageContext value={s}>
      <StorePageDynamicContext value={o}>

        <I18nextProvider i18n={i18n}>
          {children}
        </I18nextProvider>
      </StorePageDynamicContext>
    </StorePageContext>
  )
}